module.exports = __webpack_public_path__ + "img/fairy_light_2.67dde0b9.png";